import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=f375e894&scoped=true&"
import script from "./LangSwitcher.vue?vue&type=script&lang=js&"
export * from "./LangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=f375e894&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f375e894",
  null
  
)

export default component.exports